import gql from 'graphql-tag';
import {
  QuestionRuleInstanceFragment,
  QuestionRuleInstanceWithoutTagsFragment,
  ReportRuleInstanceFragment,
} from '@jupiterone/jupiter-web-toolkit';

export const GetAlerts = gql`
  query ListAlertInstances(
    $alertStatus: AlertStatus
    $limit: Int
    $cursor: String
  ) {
    listAlertInstances(
      alertStatus: $alertStatus
      limit: $limit
      cursor: $cursor
    ) {
      instances {
        id
        accountId
        ruleId
        level
        status
        lastUpdatedOn
        lastEvaluationBeginOn
        lastEvaluationEndOn
        createdOn
        dismissedOn
        lastEvaluationResult {
          rawDataDescriptors {
            name
            persistedResultType
            recordCount
          }
          outputs {
            name
            value
          }
        }
        questionRuleInstance {
          ...QuestionRuleInstanceWithoutTagsFragment
        }
        reportRuleInstance {
          ...ReportRuleInstanceFragment
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  ${QuestionRuleInstanceWithoutTagsFragment}
  ${ReportRuleInstanceFragment}
`;

export const GetAlertById = gql`
  query AlertInstanceById($id: ID!) {
    alertInstance(id: $id) {
      id
      accountId
      ruleId
      level
      status
      lastUpdatedOn
      lastEvaluationBeginOn
      lastEvaluationEndOn
      createdOn
      dismissedOn
      lastEvaluationResult {
        rawDataDescriptors {
          name
          persistedResultType
          recordCount
        }
        outputs {
          name
          value
        }
      }
      questionRuleInstance {
        ...QuestionRuleInstanceWithoutTagsFragment
      }
      reportRuleInstance {
        ...ReportRuleInstanceFragment
      }
    }
  }
  ${QuestionRuleInstanceWithoutTagsFragment}
  ${ReportRuleInstanceFragment}
`;

export const GetRule = gql`
  query GetQuestionRuleInstance($id: ID!) {
    questionRuleInstance(id: $id) {
      ...QuestionRuleInstanceFragment
    }
  }
  ${QuestionRuleInstanceFragment}
`;

export const GetRawDataUrl = gql`
  query GetRawDataDownloadUrl($rawDataKey: String!) {
    getRawDataDownloadUrl(rawDataKey: $rawDataKey)
  }
`;

export const GetAlertsByRule = gql`
  query ListResults(
    $collectionType: CollectionType!
    $collectionOwnerId: String!
    $beginTimestamp: Long!
    $endTimestamp: Long!
    $limit: Int
    $cursor: String
    $tag: String
  ) {
    listCollectionResults(
      collectionType: $collectionType
      collectionOwnerId: $collectionOwnerId
      beginTimestamp: $beginTimestamp
      endTimestamp: $endTimestamp
      limit: $limit
      cursor: $cursor
      tag: $tag
    ) {
      results {
        accountId
        timestamp
        outputs {
          name
          value
        }
        rawDataDescriptors {
          name
          rawDataKey
          persistedResultType
          recordCount
        }
        collectionType
        collectionOwnerId
        collectionOwnerVersion
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const CountAlertInstances = gql`
  query CountAlertInstances(
    $alertStatus: AlertStatus
    $limit: Int
    $cursor: String
  ) {
    countAlertInstances(
      alertStatus: $alertStatus
      limit: $limit
      cursor: $cursor
    ) {
      count
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const QuestionRuleTags = gql`
  query questionRuleTags {
    questionRuleTags
  }
`;
